import { createIsbotFromList, list } from 'isbot';

// isbot 내장 리스트가 잡지 못하는 모니터링/측정 도구 UA 보강
// (gtmetrix 는 isbot v5 기준 미포함 — 직접 추가)
const EXTRA_BOT_PATTERNS = ['gtmetrix'] as const;

// 내장 봇 패턴 + 보강 패턴을 합쳐 모듈 로드 시 1회만 정규식 생성
const matchesBot = createIsbotFromList([...list, ...EXTRA_BOT_PATTERNS]);

/**
 * 봇(크롤러) 여부 확인. userAgent 를 넘기면 그 값으로(서버),
 * 생략하면 navigator.userAgent 로(클라이언트) 판별한다.
 */
export const isBot = (userAgent?: string): boolean => {
  const ua =
    userAgent ?? (typeof navigator !== 'undefined' ? navigator.userAgent : '');
  return matchesBot(ua);
};
